import React, {useEffect} from 'react';
import {useSetting} from "store/settings";
import {handleSuccessMessages} from "store/auth";
import {Field, Form, Formik} from "formik";
import {Loading, TextArea, TextField} from "components/form";

const ContactInfo = (props) => {
   const {dispatch, getSetting, submitSetting, contact_info, loading} = useSetting();
   const key = "contact_info";

   useEffect(() => {
      dispatch(getSetting(key));
   }, [])

   if (loading) {
      return (<div className="box p-5 flex justify-center">
         <Loading/>
      </div>)
   }
   return (
      <>
         <Formik
            initialValues={contact_info || {}}
            onSubmit={async (values, {setSubmitting}) => {
               await dispatch(submitSetting({value: values, key},
                  () => handleSuccessMessages("ویرایش اطلاعات انجام شد")))
               setSubmitting(false);
            }}
            enableReinitialize
         >
            {({isSubmitting, dirty}) => (
               <Form>
                  <div className="box rounded p-3">
                     <h3>تنظیمات اطلاعات تماس</h3>
                     <hr className="my-2"/>
                     <div className="">
                        <div className="intro-x grid grid-cols-2 gap-4">
                           <Field
                              placeholder="شماره تماس"
                              label="شماره تماس :"
                              name="tell"
                              component={TextField}
                           />
                           <Field
                              placeholder="ایمیل"
                              label="ایمیل :"
                              name="email"
                              component={TextField}
                           />
                           <Field
                              placeholder="آدرس"
                              label="آدرس :"
                              name="address"
                              component={TextArea}
                           />
                           <div></div>
                           <button
                              className="mt-4 btn btn-primary w-20"
                              type="submit"
                              disabled={!!(isSubmitting || !dirty)}
                           >
                              {isSubmitting ? <Loading/> : "ذخیره"}
                           </button>
                        </div>
                     </div>
                  </div>
               </Form>
            )}
         </Formik>
      </>
   )
};

export default ContactInfo;